// src/shell/registry.js — засичане на извличане от регистъра (/api/registry/...)
// за отметката „Данни" в контактите. Пренесено от app.js; върши работа още
// при import. Обвивката пази guard (__regWrap), за да не се дублира никога.

(function () {
  if (typeof window === 'undefined' || window.__regWrap || !window.fetch) return;
  window.__regWrap = true;
  window.__registryHit = 0;
  const of = window.fetch.bind(window);
  window.fetch = function (u, o) {
    const pr = of(u, o);
    try {
      if (/\/api\/registry\//.test(String((u && u.url) || u || ''))) {
        pr.then((r) => { if (r && r.ok) window.__registryHit = Date.now(); }).catch(() => {});
      }
    } catch (_) {}
    return pr;
  };
})();
